module.exports = require("@thx/ducks");


//////////////////
// WEBPACK FOOTER
// external "@thx/ducks"
// module id = 1
// module chunks = 0